module.exports = __webpack_public_path__ + "img/formbuilderSuccessIcon.5d6de10f.svg";